import { css } from "emotion"

export const container = css``

export const selected = css`
  background: #f00;
`
